import { getID, getRandomColor } from "src/libs/utilities"
import { schema } from "../schema"
import { SCALAR_TYPES } from "src/libs/scalars"
import getRansomName from "src/libs/utilities/getRansomName"

export default function createBySchema( type: string ): any {
    const _schema = schema()[ type ]
    if(!_schema) {
        return { id: getID( type ) }
    }
    const visible_value: string = _schema.visible_value || "title"
    let item: any = { id: getID( type ), type, [visible_value]: getRansomName() }
    const apolloFields = _schema.apollo_fields
    Object.keys(apolloFields).forEach(key => {
        if( apolloFields[key].type === SCALAR_TYPES.COLOR) {
            item[ key ] = getRandomColor()
        }
    })
    return item
}